import api from './api'

/** La contraseña llega siempre enmascarada; `hasPassword` dice si hay una guardada. */
export interface MailServerType {
  id: number
  label: string
  host: string
  port: number
  secure: boolean
  username: string | null
  hasPassword: boolean
  fromEmail: string
  fromName: string | null
  auditEmail: string | null
  isDefault: boolean
  isActive: number | null
}

export interface SaveMailServerPayloadType {
  label: string
  host: string
  port?: number
  secure?: boolean
  username?: string | null
  /** Vacía = conserva la guardada en el servidor. */
  password?: string
  fromEmail: string
  fromName?: string | null
  auditEmail?: string | null
  isDefault?: boolean
  isActive?: number
}

export const mailService = {
  async list() {
    const { data } = await api.get('/mail-servers')
    return data.data as MailServerType[]
  },

  async create(payload: SaveMailServerPayloadType) {
    const { data } = await api.post('/mail-servers', payload)
    return data.data as MailServerType
  },

  async update(id: number, payload: SaveMailServerPayloadType) {
    const { data } = await api.put(`/mail-servers/${id}`, payload)
    return data.data as MailServerType
  },

  async remove(id: number) {
    const { data } = await api.delete(`/mail-servers/${id}`)
    return data.data as boolean
  },

  /** Envía un correo de prueba desde ese servidor a la dirección indicada. */
  async test(id: number, to: string) {
    const { data } = await api.post(`/mail-servers/${id}/test`, { to })
    return data.data as boolean
  }
}
